import i18n from '../i18n';

export const getErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  const code = data?.code;
  const message = data?.message || data?.error;

  if (code) {
    const translated = i18n.t(`errors:${code}`);
    if (translated && translated !== `errors:${code}` && translated !== code) {
      return translated;
    }
  }

  if (message) return message;
  if (error?.message) return error.message;
  return fallback || i18n.t('errors:UNKNOWN_ERROR');
};

export const getErrorCode = (error) => {
  return error?.response?.data?.code || null;
};
